import styled from 'styled-components/native';

export const FullWidth = styled.View`
  width: 100%;
`;

export const FullWidthFlex = styled.View`
  flex: 1;
`;
